import IdentifyPortal from "components/Card/SearchCard/components/IdentifyPortal";
import ListOfChanges from "components/Card/SearchCard/components/ListOfChanges";
import Tab from "components/Tabs/Tab";
import useProperties from "hooks/useProperties";
import React, { useState } from "react";
import { useMediaQuery } from "react-responsive";

const tabs = [
  {
    name: "Portali Identificati",
  },
  {
    name: "Lista Modifiche",
  },
];

const IdentifyPortalAndListModificationComponent = () => {
  const [activeTab, setActiveTab] = useState("Portali Identificati");
  const { propertyDetails: property } = useProperties();
  const isMobile = useMediaQuery({ query: "(max-width: 640px)" });

  return (
    <div className="mt-8 border-b border-[#F0F0F0] pb-4">
      <Tab
        activeTab={activeTab}
        setActiveTab={setActiveTab}
        tabs={tabs}
        tabStyle={{
          borderColor: "#AEAEAE4D",
          fontWeight: "400",
          fontSize: "16px",
          color: "#00000096",
          marginBottom: "16px",
        }}
        tabUnderlineBackground="#1DA1F2"
        activeTabColor="#1DA1F2"
        tabContainerStyle={{
          width: isMobile ? "auto" : "fit-content",
          marginLeft: isMobile ? "auto" : "0",
        }}
        tabButtonStyle={{ height: 38 }}
      />

      {activeTab === "Portali Identificati" ? (
        <IdentifyPortal
          property={property}
          height="auto"
          hideHeading={true}
          maxHeight={200}
        />
      ) : (
        <ListOfChanges
          property={property}
          mainStyle={{ height: "auto", maxHeight: "200px" }}
        />
      )}
    </div>
  );
};

export default IdentifyPortalAndListModificationComponent;
